import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { api } from './api';
import type { User } from './types';

type AuthValue={ user:User|null; loading:boolean; login:(email:string,password:string,captchaToken?:string)=>Promise<void>; logout:()=>Promise<void>; setUser:(u:User)=>void };
const AuthContext=createContext<AuthValue|null>(null);
export function AuthProvider({children}:{children:ReactNode}){
  const [user,setUserState]=useState<User|null>(null),[loading,setLoading]=useState(true);
  useEffect(()=>{api<{user:User}>('/auth/me').then(x=>setUserState(x.user)).catch(()=>{}).finally(()=>setLoading(false));},[]);
  const login=async(email:string,password:string,captchaToken='')=>{const x=await api<{user:User}>('/auth/login',{method:'POST',body:JSON.stringify({email,password,captchaToken})});setUserState(x.user)};
  const logout=async()=>{await api('/auth/logout',{method:'POST'});setUserState(null)};
  return <AuthContext.Provider value={{user,loading,login,logout,setUser:setUserState}}>{children}</AuthContext.Provider>
}
export const useAuth=()=>{const value=useContext(AuthContext);if(!value)throw new Error('Auth context missing');return value};
